import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  APP_BASE_HREF,
  LocationStrategy,
  PathLocationStrategy,
  PlatformLocation
} from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';

import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { appinfo } from './appinfo';

import {
  ALLOW_SCREENAUTH,
  APIGATEWAY_CONFIG,
  APPLICATION_NAME,
  COGNITO_CONFIG_HA,
  GeaMesAuthInterceptor
} from '@gea-mes/cognito';

import {
  GEA_ENVIROMENT,
  GEA_MES_NAVBAR_APPLICATION_NAME,
  GEA_MES_NAVBAR_ENV_PROD_STATUS,
  GEA_MES_NAVBAR_MENU_SERVICE,
  NavItem
} from '@gea-mes/navbar';

export function getBaseHref(platformLocation: PlatformLocation): string {
  return platformLocation.getBaseHrefFromDOM();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideToastr(),

    { provide: APP_BASE_HREF, useFactory: getBaseHref, deps: [PlatformLocation] },
    { provide: LocationStrategy, useClass: PathLocationStrategy },

    { provide: COGNITO_CONFIG_HA, useValue: environment.cognitoOptionsHA },
    { provide: APPLICATION_NAME, useValue: appinfo.name.toUpperCase() },
    { provide: APIGATEWAY_CONFIG, useValue: environment.apiGateway },
    { provide: ALLOW_SCREENAUTH, useValue: environment.AllowScreenAuth },
    { provide: HTTP_INTERCEPTORS, useClass: GeaMesAuthInterceptor, multi: true },

    { provide: GEA_MES_NAVBAR_APPLICATION_NAME, useValue: appinfo.name.toUpperCase() },
    { provide: GEA_MES_NAVBAR_ENV_PROD_STATUS, useValue: environment.production },
    { provide: GEA_ENVIROMENT, useValue: environment },
    { provide: GEA_MES_NAVBAR_MENU_SERVICE, useValue: new BehaviorSubject<NavItem[]>([]) }
  ]
};